import { Phone, Mail, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";
import { useContent } from "@/content/ContentContext";

const ContactBanner = ({ overline, title, blurb }) => {
  const { content } = useContent();
  const { site } = content;
  return (
    <section className="relative bg-pine text-cream grain overflow-hidden" data-testid="contact-banner">
      <div className="relative z-10 mx-auto max-w-7xl px-5 sm:px-8 py-24 sm:py-32">
        <Reveal>
          <p className="text-xs font-semibold tracking-[0.32em] uppercase text-gold mb-6">{overline}</p>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-medium leading-[1.08] max-w-3xl">
            {title}
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mt-6 max-w-xl text-base text-cream/70 leading-relaxed">{blurb}</p>
        </Reveal>
        <Reveal delay={0.24}>
          <div className="mt-12 grid gap-px bg-cream/10 border border-cream/10 sm:grid-cols-2 max-w-3xl">
            <a
              href={`tel:${site.phoneHref}`}
              data-testid="contact-banner-phone-link"
              className="group flex items-center justify-between gap-4 bg-pine px-7 py-7 transition-colors duration-300 hover:bg-moss"
            >
              <span>
                <span className="block text-[11px] font-semibold tracking-[0.28em] uppercase text-gold mb-2">
                  Telephone
                </span>
                <span className="font-serif text-2xl sm:text-3xl">{site.phone}</span>
              </span>
              <Phone size={22} className="text-gold transition-transform duration-300 group-hover:-translate-y-1" />
            </a>
            <a
              href={`mailto:${site.email}`}
              data-testid="contact-banner-email-link"
              className="group flex items-center justify-between gap-4 bg-pine px-7 py-7 transition-colors duration-300 hover:bg-moss"
            >
              <span>
                <span className="block text-[11px] font-semibold tracking-[0.28em] uppercase text-gold mb-2">
                  Email
                </span>
                <span className="font-serif text-lg sm:text-xl break-all">{site.email}</span>
              </span>
              <Mail size={22} className="text-gold shrink-0 transition-transform duration-300 group-hover:-translate-y-1" />
            </a>
          </div>
        </Reveal>
        <Reveal delay={0.3}>
          <Link
            to="/contact"
            data-testid="contact-banner-page-link"
            className="mt-10 inline-flex items-center gap-2 text-sm font-semibold tracking-wide text-gold link-underline-gold pb-1"
          >
            More ways to get in touch <ArrowUpRight size={16} />
          </Link>
        </Reveal>
      </div>
    </section>
  );
};

export default ContactBanner;
